var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("light-box", { on: { close: _vm.discardChanges } }, [
    _c(
      "div",
      { attrs: { slot: "light-box-content" }, slot: "light-box-content" },
      [
        !_vm.isFetching
          ? _c("mpe-editor", {
              attrs: {
                mpeStripped: _vm.getEditMpe,
                availableMedia: _vm.getMedia,
                fetchingData: _vm.isFetching
              },
              on: { discardChanges: _vm.discardChanges, updateMpe: _vm.saveMpe }
            })
          : _c(
              "div",
              { staticClass: "data-loading-popup" },
              [
                _c("q-icon", {
                  attrs: {
                    allowSelfUpdate: false,
                    spin: "",
                    width: "110px",
                    name: "spinner"
                  }
                })
              ],
              1
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cd44f88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cd44f88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/standaloneMpe/EditorWrapper.vue
// module id = null
// module chunks = 